"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toEventListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var slice_1 = require("./slice");
var toEventListSlice = function (data, logger) {
    var event_list = data.items
        .map(function (item) { return field_groups_1.toEventItem(item, logger); })
        .filter(Boolean);
    // Test liste événements non vide
    if (!(event_list === null || event_list === void 0 ? void 0 : event_list.length)) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.EventList)), { event_list: event_list }));
};
exports.toEventListSlice = toEventListSlice;
//# sourceMappingURL=event-list-slice.js.map